"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaAuth = exports.allMethods = void 0;
const _ui_1 = require("@ui");
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const react_1 = __importDefault(require("react"));
const ac_1 = require("@app/ac");
const react_redux_1 = require("react-redux");
const store_1 = __importDefault(require("@app/store"));
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const graphql_1 = require("@app/gql-types/graphql");
exports.allMethods = [graphql_1.MfaMethods.Email, graphql_1.MfaMethods.Sms, graphql_1.MfaMethods.Totp];
const MfaAuth = ({ sendMfaFactor, shouldSendOnLoad, method, setMethod, totpRes, setCode, code, email, telephone, sent, options, mode, checkMfaChallenge, goBack, authParam }) => {
    //   Setup part
    const [param, setParam] = react_1.default.useState('');
    const [anonymizedParam, setAnonymizedParam] = react_1.default.useState();
    const { loading } = store_1.default.getState();
    const dispatch = (0, react_redux_1.useDispatch)();
    const sendVerificationLoading = loading.includes('send-mfa-factor');
    const finalStepLoading = loading.includes('verify-mfa-factor') || loading.includes('log-in');
    const sendVerification = react_1.default.useCallback(async (type) => {
        const res = await sendMfaFactor({
            type,
        });
        setAnonymizedParam(res.param);
        return res.sent;
    }, [sendMfaFactor]);
    const allOptsMethod = [
        { value: graphql_1.MfaMethods.Email, label: (0, util_1.t)('EMAIL') },
        { value: graphql_1.MfaMethods.Sms, label: (0, util_1.t)('SMS') },
        { value: graphql_1.MfaMethods.Totp, label: (0, util_1.t)('MFA_METHOD.totp') },
    ];
    // Only the factors the caller actually offers: on a login screen that is what the
    // account has enrolled, in the setup modal what the workspace allows and is not
    // enabled yet. Every call site already computes that list — the select used to ignore
    // it and offer all three, which walked people into a method they had no factor for.
    const optsMethod = allOptsMethod.filter((option) => (0, util_1.isDefined)(option.value) && options.includes(option.value));
    react_1.default.useEffect(() => {
        const sendAsyncVerification = async () => {
            if (shouldSendOnLoad && method) {
                return await sendVerification(method);
            }
        };
        void sendAsyncVerification();
    }, [sendVerification, shouldSendOnLoad, method]);
    const emailRegex = react_1.default.useMemo(() => /^[^\s@]+@[^\s@]+\.[^\s@]+$/, []);
    const validEmail = method === 'email' ? emailRegex.test(param) : true;
    return (react_1.default.createElement(react_1.default.Fragment, null, !sent ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN, align: _ui_1.Flex.POSITION.CENTER },
            react_1.default.createElement(_ui_1.Dropdown, { testid: 'mfa-method-select', label: `${(0, util_1.t)('MFA_SELECT_LOGIN_METHOD')}`, size: _ui_1.Dropdown.SIZES.FULL_WIDTH, type: _ui_1.Dropdown.TYPES.VARIABLE, style: _ui_1.Dropdown.STYLES.OUTLINED, sortedOptions: false, options: optsMethod, value: optsMethod.find((o) => o.value === method), onChange: (sel) => {
                    // @ts-expect-error Type 'undefined' is not assignable to type '"email" | "sms" | "totp"'.
                    setMethod(sel.value);
                    // pre-fill my email
                    if (sel.value === 'email' && email) {
                        setParam(email);
                        authParam?.(email);
                    }
                    // pre-fill my phone number
                    if (sel.value === 'sms' && telephone) {
                        setParam(telephone);
                        authParam?.(telephone);
                    }
                }, singleSelect: true }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8 }),
            mode !== 'setup' && (react_1.default.createElement(_ui_1.Button, { testid: 'mfa-send-code-button', onClick: async () => (0, util_1.isValue)(method) ? await sendVerification(method) : undefined, size: _ui_1.Button.SIZES.FULL, style: _ui_1.Button.STYLES.CONTAINED, loading: sendVerificationLoading, label: (0, util_1.t)('MA_FORM_CONTINUE') }))),
        mode === 'setup' && (react_1.default.createElement(react_1.default.Fragment, null,
            method === 'email' && (react_1.default.createElement("div", { style: { width: '100%' } },
                react_1.default.createElement(_ui_1.Input, { size: 'full-width', label: (0, util_1.t)('EMAIL'), type: 'email', placeholder: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('REG_EMAIL_PLACEHOLDER_EMP_SHORT')), onChange: (v) => {
                        setParam(v);
                        authParam?.(v);
                    }, value: param, hasError: !validEmail }))),
            method === 'sms' && (react_1.default.createElement(_ui_1.PhoneInput, { size: _ui_1.Input.SIZES.FULL_WIDTH, value: param, label: (0, util_1.t)('YOUR_PHONE'), placeholder: (0, util_1.t)('REG_PHONE_PLACEHOLDER'), onChange: (v) => {
                    setParam(v);
                    authParam?.(v);
                }, ref: null })))))) : (react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN },
        method !== 'totp' && react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE, weight: _ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('ENTER_MFA_CODE')),
        anonymizedParam && (react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD },
            (0, util_1.t)('MFA_SENT_TO'),
            ": ",
            anonymizedParam)),
        method === 'totp' && (react_1.default.createElement(react_1.default.Fragment, null,
            mode === 'setup' && react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('MFA_PARAM_QR')),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_8 },
                react_1.default.createElement("div", { style: { textAlign: 'center' } }, totpRes && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(qrcode_react_1.default, { renderAs: 'canvas', style: { margin: '0 auto' }, value: totpRes.binding.uri }))))))),
        react_1.default.createElement(_ui_1.Input, { testid: 'mfa-code-input', size: 'full-width', label: (0, util_1.t)('MFA_CODE'), placeholder: 123456, type: 'text', onChange: v => {
                setCode(v.replace(/\s/, ''));
            }, value: code }),
        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_12 }),
        mode === 'login' && (react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.ROW, align: _ui_1.Flex.POSITION.CENTER, justify: _ui_1.Flex.POSITION.SPC_BETWEEN },
            react_1.default.createElement(_ui_1.Button, { testid: 'mfa-back-button', onClick: goBack, size: _ui_1.Button.SIZES.LARGE, style: _ui_1.Button.STYLES.OUTLINED, label: (0, util_1.t)('BACK') }),
            react_1.default.createElement(_ui_1.Button, { testid: 'mfa-submit-button', 
                // the code is always 6 digits, so this is enabled exactly when
                // there is a complete one to send. It used to read `=== 6`,
                // which greyed the button out at the only moment it was usable
                // — harmless only because `MfaForm` auto-submits on the sixth
                // character, which is what actually completes an MFA login.
                disabled: !code || code.length !== 6, onClick: async () => {
                    // This is implied by the disabled - doing this for typescript.
                    if ((0, util_1.isUndefined)(code))
                        return;
                    if (!(0, util_1.isValue)(method))
                        return;
                    const success = await checkMfaChallenge?.({
                        type: method,
                        code,
                    });
                    if (success) {
                        dispatch((0, ac_1.setModal)('setup-mfa'));
                        dispatch((0, ac_1.setModal)(null));
                    }
                }, size: _ui_1.Button.SIZES.LARGE, style: _ui_1.Button.STYLES.CONTAINED, loading: finalStepLoading, label: (0, util_1.t)('SEND') })))))));
};
exports.MfaAuth = MfaAuth;
